export { RichText } from './RichText';
export type {
  RichTextLinkComponentProps,
  RichTextProps,
} from './RichText.types';
